module.exports = __webpack_public_path__ + "static/media/moorestown-logo.d701025d.png";